import { connect } from 'react-redux';

import { FeedbackBlock } from '../../components/Feedback';
import { IState } from '../../store';
import { feedbackBannerClosed, sendFeedbackAction } from '../../store/feedback/actions';
import { IFeedbackDataRequest, IFeedbackDataResponseSchema, TModerationStatus } from '../../types';
import { TTypedThunkDispatch } from '../../types/store';

export interface IFeedbackProps {
  builderStatus: TModerationStatus;
  showFeedback: boolean;
  sendFeedbackAction(params: IFeedbackDataRequest): Promise<IFeedbackDataResponseSchema>;
  feedbackBannerClosed(): void;
}

export type TFeedbackStoreProps = Pick<IFeedbackProps, 'builderStatus' | 'showFeedback'>;
export type TFeedbackDispatchProps = Pick<IFeedbackProps, 'sendFeedbackAction' | 'feedbackBannerClosed'>;

export function mapStateToProps(state: IState): TFeedbackStoreProps {
  return {
    builderStatus: state.villageData.village.builder?.moderationStatus,
    showFeedback: state.showFeedback,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): TFeedbackDispatchProps {
  return {
    feedbackBannerClosed: () => dispatch(feedbackBannerClosed()),
    sendFeedbackAction: params => dispatch(sendFeedbackAction(params)),
  };
}

export const FeedbackContainer = connect<TFeedbackStoreProps, TFeedbackDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(FeedbackBlock);
